import React, { useCallback, useState, useEffect } from 'react';
import { groupBy, sortBy } from 'lodash';
import { Menu } from 'antd';
import { Link } from 'react-router-dom';
import UtinaIcon from 'icons/UtinaIcon';

const CustomSubMenu = ({ level, ...props }:any) => {
  const offset = level * 40; // Example calculation for offset based on depth, adjust as needed
  return (
    <Menu.SubMenu
      {...props}
      popupOffset={[0, offset]}
    />
  );
};

const MainMenu = (menuFromContext: any) => {
  const menu = menuFromContext.menuFromContext;
  const menuItemsByParentId = groupBy(menu, 'itemidparent');
  const rootMenuItems = menuItemsByParentId['0'];

  // Track selected and open keys
  const [selectedKeys, setSelectedKeys] = useState<string[]>([]);
  const [openKeys, setOpenKeys] = useState<string[]>([]);

  let iconColor = 'white';
  try {
    let them = localStorage?.getItem('theme') ?? '{}';
    const newTheme = JSON.parse(them);
    iconColor = newTheme?.textcolor;
  } catch (error) { }

  if (menu && !rootMenuItems) {
    console.warn('MainMenu - there is no root item in the menu');
  }

  const handleClick = ({ key }: { key: string }) => {
    setSelectedKeys([key]);
  };

  const handleOpenChange = (keys: string[]) => {
    setOpenKeys(keys);
  };

  const handleScroll = useCallback(() => {
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    // Here, you could adjust the offset based on scrollTop if needed
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  const renderMenuItem = useCallback(
    ({ itemid, itemlabel, pagurl, paglabel, pagicon, itemidparent, pagparams }:any, level = 0) => {
      if (itemid === itemidparent) {
        console.warn(`MainMenu - itemid ${itemid} has parent ${itemidparent}`);
        return null;
      }

      const nestedMenuItems = menuItemsByParentId[itemid];
      const icon = itemid ? (
        <UtinaIcon pagicon={pagicon} color={iconColor ?? 'white'} />
      ) : undefined;
      const label = itemlabel ?? paglabel;
      const key = `${itemlabel}-${itemid}`;

      if (nestedMenuItems !== undefined) {
        return (
          <CustomSubMenu
            key={key}
            title={label}
            icon={icon}
            level={level}
          >
            {sortBy(nestedMenuItems, 'itemorder').map(item => renderMenuItem(item, level + 1))}
          </CustomSubMenu>
        );
      }

      return (
        <Menu.Item key={key}>
          <Link to={pagurl + (pagparams === null ? '' : pagparams)}>
            {label}
          </Link>
        </Menu.Item>
      );
    },
    [menuItemsByParentId, iconColor]
  );

  return (
    <Menu
      mode="horizontal"
      className="Menu"
      selectedKeys={selectedKeys}
      openKeys={openKeys}
      onClick={handleClick}
      onOpenChange={handleOpenChange}
      triggerSubMenuAction="click"
    >
      {rootMenuItems && sortBy(rootMenuItems, 'itemorder').map(item => renderMenuItem(item))}
    </Menu>
  );
};

export default MainMenu;